import { ReferenceField, TextField } from "react-admin";

// `label` names the column when the field sits in a list.
export const ProjectField = ({ source = "projectId", sortable = false }: { source?: string; sortable?: boolean; label?: string }) => (
  <ReferenceField source={source} reference="projects" sortable={sortable} link="show">
    <TextField source="name" />
  </ReferenceField>
);
